import { Snackbar as MuiSnackbar, SnackbarProps } from "@mui/material";

export type Props = SnackbarProps;

export const Snackbar: React.FC<Props> = (props) => {
  return <MuiSnackbar {...props} />;
};
